var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPaidRequests = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4188 5.79269L13.4473 3.16401C12.9164 2.45607 11.9248 2.28623 11.1885 2.7771L6.60669 5.83167",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4189 9.58313H17.5031C17.9635 9.58313 18.3368 9.95638 18.3368 10.4168V12.9179C18.3368 13.3783 17.9635 13.7515 17.5031 13.7515H15.4189C14.2678 13.7515 13.3347 12.8184 13.3347 11.6673V11.6673C13.3347 10.5163 14.2678 9.58313 15.4189 9.58313V9.58313Z",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5031 9.58323V7.91587C17.5031 6.76479 16.5699 5.83167 15.4189 5.83167H4.58103C3.42995 5.83167 2.49683 6.76479 2.49683 7.91587V15.419C2.49683 16.5701 3.42995 17.5032 4.58103 17.5032H15.4189C16.5699 17.5032 17.5031 16.5701 17.5031 15.419V13.7516",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaidRequests, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/paidRequests.1b9dfe93.svg";
export { ForwardRef as ReactComponent };